import { cn } from "@/lib/utils";

interface MessageBubbleProps {
  own: boolean;
  userName: string;
  dateTime: string;
  badge: React.ReactNode;
  children: React.ReactNode;
}

export const MessageBubble = ({ own, userName, dateTime, badge, children }: MessageBubbleProps) => (
  <div
    className={cn(
      "my-2 max-w-[80%] rounded-2xl p-4 shadow-sm",
      own ? "self-end bg-info-100" : "self-start bg-neutral-100"
    )}
  >
    <div className="flex flex-wrap items-start justify-between gap-2">
      <div>
        <div className="font-semibold text-foreground">{userName}</div>
        <div className="font-semibold text-muted-foreground text-xs">{dateTime}</div>
      </div>
      {badge}
    </div>
    {children}
  </div>
);
